// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15CS2","delete":"styles_delete__zrIbI","update":"styles_update__ETFlA","add":"styles_add__LwC7t"};